import TransportOrderCt from "@/components/orders/control-tower/TransportOrderCt.vue";
import TransportOrderCtDetail from "@/components/orders/control-tower/TransportOrderCtDetail.vue";
import TransportOrderCtEdit from "@/components/orders/control-tower/TransportOrderCtEdit.vue";
import PodIndex from "@/components/orders/control-tower/pod/podIndex.vue";
import PodForm from "@/components/orders/control-tower/pod/podForm.vue";
import Checklistp2h from "@/components/orders/control-tower/checklistp2h/checklistP2hIndex.vue";
import QuestionAnswerP2h from "@/components/orders/control-tower/checklistp2h/questionAnswerP2h.vue";
import FormQuestionAnswerP2h from "@/components/orders/control-tower/checklistp2h/formQuestionAnswerP2h.vue";


let routesTransportOrderCT = [
    {
      path: '',
      meta: {
        title: "Orders",
      },
      name: "TransportOrderCt",
      component: TransportOrderCt
    },
    
    {
      path: 'detail/:id',
      meta: {
        title: "Order Detail",
      },
      name: "TransportOrderCtDetail",
      component: TransportOrderCtDetail
    },
    
    {
      path: 'edit/:id',
      meta: {
        title: "Order Edit",
      },
      name: "TransportOrderCtEdit",
      component: TransportOrderCtEdit
    },


    {
      path: 'pod',
      meta: {
        title: "POD",
      },
      name: "PodIndex",
      component: PodIndex
    },

    {
      path: 'ct-checklist-p2h',
      meta: {
        title: "Checklist P2h",
      },
      name: "Checklist P2H",
      component: Checklistp2h
    },

    {
      path: 'ct-question-answer-p2h/create',
      meta: {
        title: "Form Checklist P2h",
      },
      name: "Form Checklist P2H",
      component: FormQuestionAnswerP2h
    },

    {
      path: 'ct-question-answer-p2h/edit/:id',
      meta: {
        title: "Form Checklist P2h",
      },
      name: "Form Checklist P2H",
      component: FormQuestionAnswerP2h
    },


    {
      path: 'ct-question-answer-p2h',
      meta: {
        title: "Question Answer P2h",
      },
      name: "Question Answer P2H",
      component: QuestionAnswerP2h
    },

    {
      path: 'pod-form-create',
      meta: {
        title: "POD",
      },
      name: "PodForm",
      component: PodForm
    },

    {
      path: 'pod-form-update/:id',
      meta: {
        title: "POD",
      },
      name: "PodFormUpdate",
      component: PodForm
    },


    {
      path: 'pod-form-view/:id',
      meta: {
        title: "POD",
      },
      name: "PodFormView",
      component: PodForm
    },
     
    
]

export default routesTransportOrderCT
  